import type { CustomerProjectionData } from "./customer-projection.utils";

export const PROJECTED_CUSTOMER_ACQUISITION_EXPENSE_ID =
  "customer-acquisition-costs";

export const PROJECTED_CUSTOMER_SERVICING_EXPENSE_ID =
  "customer-servicing-costs";

export interface AcquisitionExpenseLike {
  id?: string;
  name?: string;
  category?: string;
  isCustomerAcquisitionCost?: boolean;
}

export function isAcquisitionRelatedExpense(
  expense: AcquisitionExpenseLike,
): boolean {
  const name = expense.name?.toLowerCase() ?? "";
  const category = expense.category?.toLowerCase() ?? "";

  return (
    expense.isCustomerAcquisitionCost === true ||
    expense.id === PROJECTED_CUSTOMER_ACQUISITION_EXPENSE_ID ||
    name.includes("customer acquisition") ||
    category.includes("customer acquisition") ||
    (category === "marketing" && name.includes("acquisition"))
  );
}

export function usesProjectedCustomerAcquisitionCosts(
  customerProjectionData?: CustomerProjectionData,
): boolean {
  return Boolean(customerProjectionData?.projections?.length);
}

/** Manual acquisition line items are superseded by projection-derived CAC. */
export function shouldExcludeAcquisitionExpenseFromBurn(
  expense: AcquisitionExpenseLike,
  customerProjectionData?: CustomerProjectionData,
): boolean {
  return (
    usesProjectedCustomerAcquisitionCosts(customerProjectionData) &&
    isAcquisitionRelatedExpense(expense) &&
    expense.id !== PROJECTED_CUSTOMER_ACQUISITION_EXPENSE_ID
  );
}
